export default __webpack_public_path__ + "static/media/Baskerville-Regular.4fa1b64d.woff";